module.exports = __webpack_public_path__ + "img/logo_bottom.931df205.png";